import React, { useState } from 'react';
import {
    Box,
    TextField,
    Button,
    Typography,
    Paper,
    CircularProgress,
    IconButton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import toast from 'react-hot-toast';
import axios from 'axios';

import { CONFIG } from "../../../../../../config";

// Dummy data for demonstration
const dummyData = {
    '12345': {
        motherName: 'Jane Doe',
        phoneNumber: '123-456-7890'
    },
    '67890': {
        motherName: 'Mary Smith',
        phoneNumber: '098-765-4321'
    }
};


const API_HOST_CRM = CONFIG.modules["crm"].host;

const UpdateManualInput = ({ handleClose, setData }) => {
    const [motherId, setMotherId] = useState('');
    const [motherName, setMotherName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [loading, setLoading] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [documentFound, setDocumentFound] = useState(false);

    const handleSearch = async () => {
        setLoading(true);

        // call the api 
        try {
            const response = await axios.get(API_HOST_CRM + `/case/${motherId}`);

            const data = response.data;

            const fetchedCase = data.case;
            setMotherName(fetchedCase?.name ? fetchedCase.name : '');
            setPhoneNumber(fetchedCase?.contact ? fetchedCase.contact : '');
            setDocumentFound(true);

        } catch (error) {
            setDocumentFound(false);
            toast.error('No document found with this Mother ID');
        }
        finally {
            setLoading(false)
        }

    };

    const handleUpdate = async () => {
        if (!documentFound) {
            toast.error('Please search for a document first');
            return;
        }

        setUpdating(true);
        try {
            const response = await axios.put(API_HOST_CRM + `/case/${motherId}`, {
                name: motherName,
                contact: phoneNumber
            });

            if (response.status === 200) {
                toast.success('Document updated successfully!');

                setData(prev => {
                    let newData = prev.map((prev) => {
                        if (prev.motherID === motherId) {
                            return {
                                ...prev,
                                name: motherName,
                                contact: phoneNumber
                            };
                        } else {
                            return prev;
                        }
                    })

                    return newData;
                });

                handleClose();
            }
        } catch (error) {
            console.error('Update error:', error);
            toast.error(error.response?.data?.message || 'Failed to update document');
        } finally {
            setUpdating(false);
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            {/* Search Section */}
            <Paper sx={{ p: 2, mb: 2 }}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField
                        fullWidth
                        label="Mother ID"
                        variant="outlined"
                        value={motherId}
                        onChange={(e) => setMotherId(e.target.value)}
                        placeholder="Enter Mother ID"
                    />
                    <Button
                        variant="contained"
                        onClick={handleSearch}
                        disabled={loading || !motherId}
                        sx={{ minWidth: '120px' }}
                        startIcon={loading ? <CircularProgress size={15} /> : <SearchIcon />}
                    >
                        {loading ? '' : 'Search'}
                    </Button>
                </Box>
            </Paper>

            {/* Form Section */}
            {documentFound && (
                <Paper sx={{ p: 2, position: 'relative' }}>
                    <IconButton
                        onClick={() => setDocumentFound(null)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        Document Details
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <TextField
                            fullWidth
                            label="Mother Name"
                            variant="outlined"
                            value={motherName}
                            onChange={(e) => setMotherName(e.target.value)}
                        />
                        <TextField
                            fullWidth
                            label="Phone Number"
                            variant="outlined"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleUpdate}
                            disabled={updating || !documentFound}
                            sx={{ minWidth: '120px', mt: 2 }}
                            startIcon={updating ? <CircularProgress size={15} /> : null}
                        >
                            {updating ? 'Updating...' : 'Update'}
                        </Button>
                    </Box>
                </Paper>
            )}
        </Box>
    );
};

export default UpdateManualInput;